module.exports = __webpack_public_path__ + "static/media/xray-training-medial-nonflex2.9b2923b0.png";